import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { emitFocusFormInput } from '../../events';
import { useFormTableName } from './TanstackFormTable';

export const useFocusTableRowField = (fieldName?: string, index?: number) => {
  const name = useFormTableName();
  const { getValues } = useFormContext();

  return useCallback(() => {
    if (fieldName) {
      const newRowIndex =
        typeof index === 'number' ? index : getValues(name).length - 1;
      const newRowName = `${name}.${newRowIndex}.${fieldName}`;

      const timeoutId = setTimeout(() => {
        emitFocusFormInput(newRowName);
      });
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [fieldName, index, getValues, name]);
};
